import { useParams, useSearch } from '@tanstack/react-router';

import { ErrorFallback } from '@/shared/components/error-fallback';
import { CheckoutForm } from '../ui';

export function CheckoutPage() {
  const workspaceId = useParams({
    from: '/workspace/$workspaceId',
    select: (params) => params.workspaceId,
  });
  const { productId, priceId } = useSearch({
    from: '/workspace/$workspaceId',
    select: (search) => {
      return {
        productId: search.productId,
        priceId: search.priceId,
      };
    },
  });

  if (workspaceId === undefined || productId === undefined || priceId === undefined) {
    return (
      <ErrorFallback
        title="Invalid parameters"
        error={
          new Error(`workspaceId: ${workspaceId}, productId: ${productId}, priceId: ${priceId}`)
        }
      />
    );
  }

  return <CheckoutForm workspaceId={workspaceId} productId={productId} priceId={priceId} />;
}
